import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import React, { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import Layout from '@components/Layout';
import { db } from '@root/firebase';
import { toast } from 'react-hot-toast';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
} from 'firebase/firestore';

const MySwal = withReactContent(Swal);

function FaqAdmin() {
  const { globalUser, logout } = useAuth();

  // State for FAQs and form inputs
  const [faqData, setFaqData] = useState([]);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');

  // Firestore collection reference
  const faqCollection = collection(db, 'faqs');

  // Fetch FAQs from Firestore
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const q = query(faqCollection, orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(q);
        const faqs = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFaqData(faqs);
      } catch (error) {
        toast.error('Error fetching FAQs');
        console.error(error);
      }
    };

    fetchFaqs();
  }, []);

  // Handle new FAQ submission
  const handleAddFaq = async (e) => {
    e.preventDefault();
    if (!question || !answer) {
      toast.error('Both fields are required');
      return;
    }

    try {
      const newFaq = {
        question,
        answer,
        createdAt: new Date(),
      };
      await addDoc(faqCollection, newFaq);

      // Update UI immediately
      setFaqData((prevFaqs) => [{ id: Date.now(), ...newFaq }, ...prevFaqs]);
      setQuestion('');
      setAnswer('');
      toast.success('FAQ added successfully');
    } catch (error) {
      toast.error('Error adding FAQ');
      console.error(error);
    }
  };

  return (
    <Layout isAdminPage={true}>
      <div className='row'>
        {/* FAQ Accordion */}
        <div className='col-xl-6'>
          <div className='card'>
            <div className='card-header'>
              <h4 className='card-title'>Frequently Asked Questions</h4>
              <p className='card-title-desc'>
                Click the accordions below to expand/collapse the content.
              </p>
            </div>
            <div className='card-body'>
              <div className='accordion' id='accordionExample'>
                {faqData.map((item, index) => (
                  <div className='accordion-item' key={item.id}>
                    <h2 className='accordion-header' id={`heading${item.id}`}>
                      <button
                        className='accordion-button fw-medium collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target={`#collapse${item.id}`}
                        aria-expanded='false'
                        aria-controls={`collapse${item.id}`}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse${item.id}`}
                      className='accordion-collapse collapse'
                      aria-labelledby={`heading${item.id}`}
                      data-bs-parent='#accordionExample'
                    >
                      <div className='accordion-body'>
                        <div className='text-muted'>
                          <strong className='text-dark'>
                            {item.question}:
                          </strong>{' '}
                          {item.answer}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Add New FAQ Form */}
        <div className='col-xl-6 mx-auto'>
          <div className='card'>
            <div className='card-header'>
              <h4 className='card-title'>Create New FAQ</h4>
            </div>
            <div className='card-body'>
              <form onSubmit={handleAddFaq}>
                <div className='form-floating mb-3'>
                  <input
                    type='text'
                    className='form-control'
                    name='question'
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    required
                  />
                  <label htmlFor='question'>Question</label>
                </div>

                <div className='form-floating mb-3'>
                  <ReactQuill
                    theme='snow'
                    value={answer}
                    onChange={setAnswer}
                    className='faq-editor'
                  />
                </div>

                <div>
                  <button type='submit' className='btn btn-primary w-md'>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default FaqAdmin;
